module.exports = __webpack_public_path__ + "img/VITAN.da4d73ee.png";